import styled from 'styled-components';

type ContainerProps = {
  logged?: boolean
}

export const Container = styled.header<ContainerProps>`
  width: 100%;
  height: 6rem;
  background: ${props => props.theme.colors.white_variant};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.6rem;

  display: ${props => props.logged ? 'flex' : 'none'}; 
  

`;

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  margin-left: 2rem;

  span {
    margin-left: 1rem;
    font-weight: 500;
    font-size: 1.2rem;
  }
`;

export const LeftSectionMobile = styled.div`
  display: flex;
  align-items: center;
  flex: 1;

  span {
    font-weight: 500;
    font-size: 12px;
  }
`;

export const RightSect = styled.div`
  display: flex;
  align-items: center;
  margin-right: 2rem;
  
  .mobile & {
    margin-right: 0;
  }

  .stat {
    margin-left: 1rem;
    font-weight: 500;
    font-size: 1.2rem;
  }

  .mobile & .stat {
    font-size: 12px;
    margin-left: 1rem;
  }

  #medcoin {
    margin-left: 3.6rem;
  }
`;

export const ContainerMobile = styled.header<ContainerProps>`
  > .header {
    position: relative;
    background-color: #ffffff;
    height: 30px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    padding: 6px 0px;
    z-index: 10;
  }

  .hamburguer-header {
    margin-left: 14px;
    cursor: pointer;
    z-index: 1;
  }

  .logo-header {
    position: absolute;
    width: 100%;
    height: 36px;
  }

  .header-menu {
    position: absolute;
    width: 100%;
    background: #FAFAFA;

    > div {
      z-index: 9;
      position: absolute;
      transition: top 0.15s ease-out;
      background: #FAFAFA;
      width: calc(100% - 28px);
      margin: 0 14px;
      display: flex;
      justify-content: center;
    }

    .slide-in {
      top: calc(14px);
    }

    .slide-out {
      top: -14px;
    }

    .hr {
      height: 1px;
      background: #E4E4E4;
      margin: 7px 0;
    }

    .menu-mobile {
      border-radius: 40px;
      padding: 0.8rem 22px;
    }

    .submenu-mobile {
      padding: 0 0.8rem;
    }

    .submenu-mobile > li {
      display: flex;
      align-items: center;
      gap: 22px;
    }

    .submenu-mobile-item {
      width: 10px;
      height: 10px;
      background: #5D5D5D;
      border-radius: 10px;
    }
  }

  .menu-select > div {
    background: #ffffff;
    display: flex;
    align-items: center;
    height: 40px;
    padding-left: 15px;
    gap: 10px;
    margin-bottom: 10px;
    color: #5D5D5D;
    font-size: 12px;
    font-weight: 700;
  }

  .mobile & > .header {
    margin-bottom: 0;
    box-shadow: 0px 1px 5px #d8d8d8;
  }

  .header-info {
    background: #ffffff;
    display: flex;
    height: 52px;
    align-items: center;
    margin: 0 15px 15px 15px;
    border-radius: 10px;
    padding: 0 10px;
  }
`;